// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PgY1","content":"styles_content__1Be1P"};